export const globalVars = {
    buffTimers: [],
    natGCOnScreen: false,
};
